import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const editModalPackageSlice = createSlice({
    name: "editModalPackage",
    initialState,
    reducers: {
        openModal: (state, action) => {
            const itemId = action.payload;
             state[itemId] = true;
          },
          closeModal: (state, action) => {
            const itemId = action.payload;
            state[itemId] = false;
          },
    },
});

export const { openModal, closeModal } = editModalPackageSlice.actions;
export default editModalPackageSlice.reducer;
